var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTwitterDesktopCaret = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 11,
  height: 6,
  viewBox: "0 0 11 6",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M11 .63a.61.61 0 0 1-.197.451L5.955 5.822A.62.62 0 0 1 5.5 6a.62.62 0 0 1-.455-.178L.197 1.082a.61.61 0 0 1 0-.897A.65.65 0 0 1 .659 0a.6.6 0 0 1 .447.193L5.5 4.474 9.894.193A.64.64 0 0 1 10.356 0q.265 0 .455.185A.6.6 0 0 1 11 .63"
})));
export default SvgTwitterDesktopCaret;